import YoutubeEmbed from '../YoutubeEmbed'

import ExceptionalROI from '../../Icons/realestateinvestor/exceptionalroi.svg'
import CoversionsAndResponseRate from '../../Icons/landingpages/conversionrates.svg'
import IncreasedInvestment from '../../Icons/landingpages/increasedinvestment.svg'
import ResultsDrivenModal from '../Modals/ResultsDrivenModal'
import BookACallButton from '../Buttons/Specials/BookACallButton'

export default function WhyDirectMail() {
    const WhyDM = [
        {
            icon: ExceptionalROI,
            title: 'High ROI',
            desc: 'Direct mail delivers outstanding returns on investment.',
        },
        {
            icon: CoversionsAndResponseRate,
            title: 'Better Conversion Rates',
            desc: 'Direct mail achieves higher conversion and response rates.',
        },
        {
            icon: IncreasedInvestment,
            title: 'Increased Investment',
            desc: 'More marketers are increasing their direct mail spend in 2024.',
        },
    ]
    return (
        <div
            id="whydirectmail"
            className="max-w-full w-[1200px] mx-auto md:mt-16 mt-[-3rem] mb-[4.6rem]">
            <div className="flex flex-col items-center text-center space-y-8 px-10 pt-5">
                <h3 className="font-bold space-x-4 text-3xl px-4 md:text-[44px] md:leading-[52px]">
                    <span className="olm-gradient-text">Proven Success</span>
                    <br className="md:hidden block" />
                    <span>Why Direct Mail? </span>
                </h3>
                <div className="md:px-12 w-full">
                    <YoutubeEmbed
                        cssClass={'rounded-xl w-full'}
                        url="https://www.youtube.com/watch?v=_aMzfNMYXBg"
                    />
                </div>
                <div className="flex flex-row md:flex-nowrap flex-wrap w-full md:space-x-4 md:space-y-0 space-y-4">
                    {WhyDM.map((why, i) => {
                        const Icon = why.icon
                        return (
                            <div
                                className="md:w-1/3 w-full bg-olm-gradient-t-to-b p-[1px] rounded-[20px] shadow-[0_4px_20px_rgba(242,130,48,0.2)]"
                                key={i}>
                                <div className="h-full flex flex-col items-center justify-center bg-white md:py-20 py-12 md:px-8 px-[40px] space-y-4 rounded-[20px]">
                                    <div className="my-5">
                                        <Icon />
                                    </div>
                                    <h3 className="font-bold text-[25px] leading-7">
                                        {why.title}
                                    </h3>
                                    <p className="md:text-xl text-lg text-[#444241]">
                                        {why.desc}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="w-96 pt-10 max-w-full">
                    <BookACallButton Modal={ResultsDrivenModal} />
                </div>
            </div>
        </div>
    )
}
